import './style.sass';

import clsx from 'clsx';
import React from 'react';

import FullWrapper from '../../layouts-components__common-cases/full-wrapper';

const DefaultResultList = ({ listResultInfo, customClass }) => {
    return (
        <FullWrapper className="default-resultList">
            <div className="default-resultWrapper">
                <div
                    dangerouslySetInnerHTML={{ __html: listResultInfo.title }}
                    className="default-resultTitle"
                />
                <div className="default-resultItems">
                    {listResultInfo.items.map((item, index) => (
                        <div key={index} className="default-resultItem">
                            <div className={clsx('default-resultItemContainer', customClass)}>
                                <img
                                    alt="СписокРезультатов"
                                    className="default-resultItemIcon"
                                    src={item.icon}
                                />
                                <div
                                    dangerouslySetInnerHTML={{ __html: item.name }}
                                    className="default-resultItemName"
                                />
                                {item.description && (
                                    <div
                                        dangerouslySetInnerHTML={{ __html: item.description }}
                                        className="default-resultItemDescription"
                                    />
                                )}
                            </div>
                        </div>
                    ))}
                </div>
                {listResultInfo.text && (
                    <div
                        dangerouslySetInnerHTML={{ __html: listResultInfo.text }}
                        className="default-resultText"
                    />
                )}
            </div>
        </FullWrapper>
    );
};
export default DefaultResultList;
